/***
 * Access Token & User Cookies
 * @type {string}
 */
const cookieAuth = "session"
const cookieData = "user"
const guestData = "guest"
const cookieRefresh = "refresh"
const cartData = "cartData"

export {cookieData,cookieAuth,cookieRefresh,guestData,cartData}
